const baseURL = "https://v2.convertapi.com";
const secret = process.env.REACT_APP_CONVERT_API_SECRET;

interface UserResponse {
  Secret: string;
  ApiKey: number;
  Active: boolean;
  FullName: string;
  Email: string;
  SecondsLeft: number;
}

export const fetchUser = (requestInit?: RequestInit) => (
  fetch(`${baseURL}/user?Secret=${secret}`, requestInit)
    .then<UserResponse>(res => res.json())
);
